import React, { useState, useEffect } from 'react';
import { getPRsInDateRangForDevelopersFromDB } from '../../../services/apiServices';
import PRLineChart from './PRLineChart';
import PRBarChart from './PRBarChart';
import SearchForm from '../../common/SearchForm';
import { Container, Modal, Row, Col, Spinner } from 'react-bootstrap';

const PRHistoryChart = () => {
    const firstDay = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0];
    const currDay = new Date().toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(firstDay);
    const [endDate, setEndDate] = useState(currDay);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState(null);
    const [prData, setPrData] = useState([]);


    useEffect(() => {
        const getprData = async () => {
            let allPrDetails = await getPRsInDateRangForDevelopersFromDB({
                platform: formData.platform,
                selectedRepositoryId: formData.selectedRepositoryId,
                selectedDeveloperNames: formData.selectedDeveloperNames,
                startDate: formData.startDate,
                endDate: formData.endDate
            });
            setPrData(allPrDetails)
        }
        if (formData && (formData?.selectedDeveloperNames.length > 0) && (formData.selectedRepositoryId.length > 0)) {
            getprData();
        }
        setShowModal(false);
    }, [formData]);

    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <Container fluid>
                <SearchForm
                    setFormData={setFormData}
                    setShowModal={setShowModal}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <Row style={{ paddingTop: 8, paddingInline: 12, paddingBottom: 20}}>
                    <Col xs={12} style={{ marginBottom: 24 }}>
                        <PRLineChart
                            data={prData}
                        />
                    </Col>
                    <Col xs={12}>
                        <PRBarChart
                            data={prData}
                        />
                    </Col>
                </Row>
            </Container>
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body className='modal-body-wrapper'><Spinner animation="border" variant="warning" /></Modal.Body>
            </Modal>
        </>
    );
};

export default PRHistoryChart;